import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Container } from './ui/Container';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    question: '¿En qué formato recibo los materiales?',
    answer: 'Todos los materiales son 100% digitales. Recibirás archivos en formato PDF listos para imprimir y documentos editables (Word/PowerPoint) para que puedas adaptarlos a tus necesidades.'
  }, {
    question: '¿Cuándo recibo mi compra?',
    answer: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un correo electrónico con el enlace de descarga y también podrás descargarlos directamente desde la pantalla de confirmación.'
  }, {
    question: '¿Ofrecen reembolsos?',
    answer: 'Sí, ofrecemos una garantía de 7 días gestionada por nuestra plataforma de pago. Los reembolsos se evalúan caso a caso y se otorgan en situaciones justificadas como errores técnicos graves.'
  }, {
    question: '¿Es una suscripción mensual?',
    answer: 'No. Es un pago único. Pagas una vez y el material es tuyo para siempre, sin cargos recurrentes ni sorpresas.'
  }, {
    question: '¿Puedo compartir los materiales con otros docentes?',
    answer: 'La licencia de uso es personal e intransferible. Está prohibida la reventa, redistribución o compartición masiva del contenido. Si tu institución necesita múltiples licencias, contáctanos.'
  }, {
    question: '¿Cómo contacto a soporte?',
    answer: 'Puedes escribirnos a tgtflipllc@activapleno.com para cualquier consulta antes o después de tu compra. Respondemos en días hábiles.'
  }];
  return <Section id="faq" background="white" data-id="element-10">
      <Container data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-13">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-brand-navy-700" data-id="element-14">
            Resolvemos tus dudas para que conozcas mejor nuestros servicios y
            recursos.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-15">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-16" />)}
        </div>
      </Container>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-brand-cream-100 rounded-lg overflow-hidden bg-brand-cream-50" data-id="element-17">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none hover:bg-white transition-colors" data-id="element-18">
        <span className="font-bold text-brand-navy-900 text-lg" data-id="element-19">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-brand-navy-700 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-20" />
      </button>
      <AnimatePresence data-id="element-21">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-22">
            <div className="p-6 pt-0 text-brand-navy-700 leading-relaxed border-t border-brand-cream-100/50" data-id="element-23">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}